// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-components-stories-template-stories-template-js": function componentSrcComponentsStoriesTemplateStoriesTemplateJs() {
    return import("./../../src/components/StoriesTemplate/StoriesTemplate.js"
    /* webpackChunkName: "component---src-components-stories-template-stories-template-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-us-index-js": function componentSrcPagesAboutUsIndexJs() {
    return import("./../../src/pages/about-us/index.js"
    /* webpackChunkName: "component---src-pages-about-us-index-js" */
    );
  },
  "component---src-pages-imprint-js": function componentSrcPagesImprintJs() {
    return import("./../../src/pages/imprint.js"
    /* webpackChunkName: "component---src-pages-imprint-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-newsroom-contact-js": function componentSrcPagesNewsroomContactJs() {
    return import("./../../src/pages/newsroom/contact.js"
    /* webpackChunkName: "component---src-pages-newsroom-contact-js" */
    );
  },
  "component---src-pages-newsroom-index-js": function componentSrcPagesNewsroomIndexJs() {
    return import("./../../src/pages/newsroom/index.js"
    /* webpackChunkName: "component---src-pages-newsroom-index-js" */
    );
  },
  "component---src-pages-newsroom-media-gallery-brand-js": function componentSrcPagesNewsroomMediaGalleryBrandJs() {
    return import("./../../src/pages/newsroom/media-gallery/brand.js"
    /* webpackChunkName: "component---src-pages-newsroom-media-gallery-brand-js" */
    );
  },
  "component---src-pages-newsroom-media-gallery-js": function componentSrcPagesNewsroomMediaGalleryJs() {
    return import("./../../src/pages/newsroom/media-gallery.js"
    /* webpackChunkName: "component---src-pages-newsroom-media-gallery-js" */
    );
  },
  "component---src-pages-newsroom-media-gallery-management-board-js": function componentSrcPagesNewsroomMediaGalleryManagementBoardJs() {
    return import("./../../src/pages/newsroom/media-gallery/management-board.js"
    /* webpackChunkName: "component---src-pages-newsroom-media-gallery-management-board-js" */
    );
  },
  "component---src-pages-newsroom-media-gallery-products-js": function componentSrcPagesNewsroomMediaGalleryProductsJs() {
    return import("./../../src/pages/newsroom/media-gallery/products.js"
    /* webpackChunkName: "component---src-pages-newsroom-media-gallery-products-js" */
    );
  },
  "component---src-pages-newsroom-media-gallery-supply-chain-js": function componentSrcPagesNewsroomMediaGallerySupplyChainJs() {
    return import("./../../src/pages/newsroom/media-gallery/supply-chain.js"
    /* webpackChunkName: "component---src-pages-newsroom-media-gallery-supply-chain-js" */
    );
  },
  "component---src-pages-newsroom-press-releases-js": function componentSrcPagesNewsroomPressReleasesJs() {
    return import("./../../src/pages/newsroom/press-releases.js"
    /* webpackChunkName: "component---src-pages-newsroom-press-releases-js" */
    );
  },
  "component---src-pages-newsroom-stories-js": function componentSrcPagesNewsroomStoriesJs() {
    return import("./../../src/pages/newsroom/stories.js"
    /* webpackChunkName: "component---src-pages-newsroom-stories-js" */
    );
  },
  "component---src-pages-sustainability-index-js": function componentSrcPagesSustainabilityIndexJs() {
    return import("./../../src/pages/sustainability/index.js"
    /* webpackChunkName: "component---src-pages-sustainability-index-js" */
    );
  }
};